import { Reducer } from 'redux';
import { DetalheVeiculoState, DetalheVeiculoTypes } from './types';

const INITIAL_STATE: DetalheVeiculoState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<DetalheVeiculoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DetalheVeiculoTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DetalheVeiculoTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case DetalheVeiculoTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case DetalheVeiculoTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
